import Vue from "vue";
import { agentApplicationsMapActions } from "@/store/modules/agentApplications";
import { makeBlobUrlFromBase64 } from "@/helpers/downloadLossForm";
import { getOrigin } from "@/helpers";
export default Vue.extend({
  data() {
    return {
      loading: false,
      loadingText: "",
      errorMessage: ""
    };
  },
  methods: {
    ...agentApplicationsMapActions([
      "printAgentApplication",
      "printBulkAgentApplications"
    ]),

    async getAgentApplicationURL(
      agentApplicationId: string,
      printMethod: string = "old"
    ) {
      try {
        this.loading = true;
        const data = {
          _id: agentApplicationId,
          printMethod
        };
        const fileURL = await this.printAgentApplication(data);
        return makeBlobUrlFromBase64(fileURL.document);
      } finally {
        this.loading = false;
      }
    },
    async printCallback(
      agentApplicationId: string,
      printMethod: string = "old"
    ) {
      const newTab = window.open(
        `${getOrigin()}/loading-preview/noMessage`,
        "_blank"
      );
      try {
        this.loadingText = "Printing agent application. Please wait...";
        const fileURL = await this.getAgentApplicationURL(
          agentApplicationId,
          printMethod
        );
        if (fileURL) {
          if (newTab) {
            newTab.location.href = fileURL;
          }
          this.$appNotifySuccess("Agent Application printed.");
        }
      } catch (error) {
        newTab?.close();
        this.errorMessage = error.message;
        this.$bugSnagClient.notify(error);
        this.$appNotifyError(this.errorMessage);
      } finally {
        this.loadingText = "";
      }
    },
    async bulkPrintCallback(_ids: string[], printMethod: string = "old") {
      const newTab = window.open(
        `${getOrigin()}/loading-preview/noMessage`,
        "_blank"
      );
      try {
        this.loadingText =
          "Printing selected agent applications. Please wait...";
        this.loading = true;
        const data = { _ids, printMethod };
        const fileURL = await this.printBulkAgentApplications(data);
        const blobUrl = makeBlobUrlFromBase64(fileURL.document);
        if (blobUrl) {
          if (newTab) {
            newTab.location.href = blobUrl;
          }
          this.$appNotifySuccess("Agent Applications printed.");
        }
      } catch (error) {
        newTab?.close();
        this.errorMessage = error.message;
        this.$bugSnagClient.notify(error);
        this.$appNotifyError(this.errorMessage);
      } finally {
        this.loading = false;
        this.loadingText = "";
      }
    }
  }
});
